export default "__VITE_ASSET__B9s1Wc4O__"